import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchAllForPassBucket(apiKey, passBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `pass_buckets/${passBucket}/passes`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.passes);
        }
      );
    });
  },

  fetchAllForPerson(apiKey, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/${person}/passes`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.passes);
        }
      );
    });
  },

  fetchAllForEventBucket(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${eventBucket}/passes`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.passes);
        }
      );
    });
  },

  fetchAllForEventBucketIncludingGlobal(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${eventBucket}/passes_including_global`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.passes);
        }
      );
    });
  },

  fetchOne(apiKey, pass) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `passes/${pass}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassSubscription(apiKey, passSubscription) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `pass_subscriptions/${passSubscription}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAutocomplete(apiKey, query, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `passes/autocomplete?event_bucket=${eventBucket}&query=${query}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassTransferHistory(apiKey, passId, eventBucketId) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `passes/${passId}/history?event_bucket=${eventBucketId}`,
          api_key: apiKey

        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, pass, values) {
    if (
      values.supplementary_data &&
      typeof values.supplementary_data !== "string"
    ) {
      values.supplementary_data = JSON.stringify(values.supplementary_data);
    }

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${pass}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  transfer(apiKey, pass, recipient) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${pass}/transfer`,
          json: { destination_email: recipient },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  transferBulk(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "passes/transfer",
          json: data,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  cancelTransfer(apiKey, pass) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${pass}/cancel_transfer`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  cancelTransfersBulk(apiKey, passIds) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "passes/cancel_transfers",
          json: {
            pass_ids: passIds
          },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, accountToken, pass) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `passes/${pass}`,
          api_key: apiKey,
          qs: {
            token: accountToken
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  deleteBulk(apiKey, accountToken, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: "passes/delete",
          json: data,
          api_key: apiKey,
          qs: {
            token: accountToken
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  editPassSubscription(apiKey, passSubscription, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `pass_subscriptions/${passSubscription}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PassUtil.js